import { render, staticRenderFns } from "./RChangeRequestButton.vue?vue&type=template&id=5c1adb07&scoped=true&"
import script from "./RChangeRequestButton.vue?vue&type=script&lang=js&"
export * from "./RChangeRequestButton.vue?vue&type=script&lang=js&"
import style0 from "./RChangeRequestButton.vue?vue&type=style&index=0&id=5c1adb07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1adb07",
  null
  
)

export default component.exports